import { FormControl, TextField } from '@mui/material';
import React, { useCallback } from 'react';

type Props = {
	label: string;
	setValue: (value: string) => void;
	value: string;
	helperText?: React.ReactNode;
	// eslint-disable-next-line react/require-default-props
	order?: number;
};

const TextControl: React.FC<Props> = ({
	value,
	setValue,
	label,
	helperText,
	order,
	...rest
}: Props) => {
	const onChange = useCallback(
		(e: { target: { value: string } }) => {
			setValue(e.target.value);
		},
		[setValue]
	);

	return (
		<FormControl fullWidth margin="normal" component="fieldset" sx={{ order }}>
			<TextField
				defaultValue={value}
				onChange={onChange}
				label={label}
				helperText={helperText}
				{...rest}
			/>
		</FormControl>
	);
};

TextControl.defaultProps = {
	helperText: undefined
};

const MemoTextControl = React.memo(TextControl);

export { MemoTextControl as TextControl };
